export const SUPPORTED_DATETIMEPICKER_LOCALES = ['fr', 'en', 'es', 'de', 'it', 'nl'];

const corePromise = import('./datetimepicker_refactored');
const localePromises = {};

export function resolveDatetimepickerLocale(locale = window.currentLocale) {
  const requestedLocale = locale || 'fr';
  return SUPPORTED_DATETIMEPICKER_LOCALES.includes(requestedLocale) ? requestedLocale : 'fr';
}

function loadDatetimepickerLocale(locale) {
  switch (locale) {
    case 'en':
      return import('./datetimepicker.en');
    case 'es':
      return import('./datetimepicker.es');
    case 'de':
      return import('./datetimepicker.de');
    case 'it':
      return import('./datetimepicker.it');
    case 'nl':
      return import('./datetimepicker.nl');
    case 'fr':
    default:
      return import('./datetimepicker.fr');
  }
}

export async function loadDatetimepickerAssets(locale = window.currentLocale) {
  const resolvedLocale = resolveDatetimepickerLocale(locale);
  if (!localePromises[resolvedLocale]) {
    // Locale modules read `$.fn.datetimepicker.dates` at evaluation time, which
    // the core module assigns. Load core first, then locale — `Promise.all`
    // races the module-body evaluations and breaks on warm-cache reloads.
    localePromises[resolvedLocale] = corePromise.then(() => loadDatetimepickerLocale(resolvedLocale));
  }
  await localePromises[resolvedLocale];
  return resolvedLocale;
}

export function withDatetimepickerLocale(options = {}, locale = window.currentLocale) {
  const targetLocale = options.language || locale;
  return {
    ...options,
    language: resolveDatetimepickerLocale(targetLocale),
  };
}
